import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const permissionsApi = createApi({
  reducerPath: 'permissionsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getPermissions: builder.query({
      query: () => ({
        url: urls.permissions,
      }),
    }),
    deletePermission: builder.mutation({
      query: (id) => ({
        url: `${urls.permissions}/${id}`,
      }),
    }),
  }),
});

export const { useGetPermissionsQuery, useDeletePermissionMutation } =
  permissionsApi;
